module.exports = __webpack_public_path__ + "img/img_whenIsUseful3.bf20b610.svg";